/*
 * @Author: 李文敬
 * @version: 1.0.0
 * @Company: 和顺旭基(深圳)中医药科技有限公司
 * @Description:
 * @Date: 2021-06-21 14:49:25
 * @LastEditors: 李文敬
 * @LastEditTime: 2025-03-18 09:25:36
 */
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = []

routes.push({
  path: '/',
  name: '首页',
  redirect: '/home'
})

const routesList = [
  'home',
  'article/:parent_id/:id',
  'pharmacopoeia/:parent_id/:id',
  'storeInformation',
  'hkWellsoon',
  'aboutUs/:parent_id/:id',
  'news/:parent_id/:id'
  // 'chargeMode'
]

routesList.map(item => {
  routes.push({
    path: `/${item}`,
    name: item.split('/')[0],
    component: resolve => require([`@/view/${item.split('/')[0]}`], resolve)
  })
})

const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}

export default new Router({
  routes
})



// WEBPACK FOOTER //
// ./src/router/index.js